import * as React from "react";
import { useFetchCLForActiveVariant } from "../../../../../../../../../hooks/modules/EcommContent/ContactLensesEcommContent/components/CLPrescriptionSelector/hooks/use-fetch-cl-for-active-variant.js";
import { NoRxSelectionColumn } from "./NoRxSelectionColumn.js";
const NoRxSelectionColumnContainer = (props) => {
  const { eyeSideId } = props;
  useFetchCLForActiveVariant({ eyeSide: eyeSideId });
  return /* @__PURE__ */ React.createElement(NoRxSelectionColumn, { ...props });
};
export {
  NoRxSelectionColumnContainer
};
//# sourceMappingURL=NoRxSelectionColumnContainer.js.map
